import {} from 'react';
import { Button as _Button, styled } from '@material-ui/core';
import { SPACING_LARGE, SPACING_SMALL } from '../../constant/spacing';
import { COLOR_TEXT_MAIN, COLOR_BUTTON_TEXT } from '../../../theme/colors';

const Button = styled(({ children, ...props }) => <_Button {...props}>{children}</_Button>)({
  fontWeight: 700,
  fontSize: SPACING_SMALL,
  lineHeight: '100%',
  height: SPACING_LARGE,
  margin: 'auto 0',
  //color: COLOR_BUTTON_TEXT,
  //backgroundColor: COLOR_TEXT_MAIN,
  '&.MuiButton-outlined': {
    color: COLOR_TEXT_MAIN,
    backgroundColor: 'transparent',
    border: `2px solid ${COLOR_TEXT_MAIN}`,
    '& a': {
      color: COLOR_TEXT_MAIN,
      textDecoration: 'none',
    },
  },
  '&.MuiButton-contained': {
    color: COLOR_BUTTON_TEXT,
    backgroundColor: COLOR_TEXT_MAIN,
    '& a': {
      color: COLOR_BUTTON_TEXT,
      textDecoration: 'none',
    },
  },
  '&:hover': {
    boxShadow:
      '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);',
  },
});
export default Button;
